<template>
<!--<div v-if="data" class="dust-haze-chart-group">-->
<!--  <dimension-weather-chart-->
<!--    v-if="hasAllWindFactor"-->
<!--    ref="chart"-->
<!--    :data-config="data"-->
<!--    :dimension="0"-->
<!--    :unit-prop="unitProp"-->
<!--    download-name="综合分析"-->
<!--    chart-min-height="300px"-->
<!--  />-->
<!--  <x-y-chart-->
<!--    v-else-->
<!--    ref="chart"-->
<!--    :data-config="data"-->
<!--    :unit-prop="unitProp"-->
<!--    chart-type="line"-->
<!--    :stack-type="1"-->
<!--    download-name="综合分析"-->
<!--    chart-min-height="300px"-->
<!--    chart-height="auto"-->
<!--    selected-change-with-data-changed-->
<!--    need-resize-->
<!--  />-->
<!--</div>-->
<trend-related-chart
  v-if="data"
  ref="chart"
  :data-config="data"
  :unit-prop="unitProp"
  :chart-height="chartHeight"
  :download-name="downloadName"
  :related-chart-width="relatedChartWidth"
  :scale="true"
/>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'
import DimensionWeatherChart from '../../../../components/Data/ChartWrapper/DimensionWeatherChart'
import TrendRelatedChart from '../../../../components/Data/TrendRelatedChart'

export default {
  name: 'DustHazeChartGroup',
  components: {TrendRelatedChart, DimensionWeatherChart},
  extends: BaseStore,
  props: {
    site: {
      required: true,
      type: Object
    },
    dataConfig: {
      required: true
    },
    defaultFactorIds: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    },
    relatedChartWidth: {
      type: String,
      default: '418px'
    },
    chartHeight: {
      type: String,
      default: 'auto'
    },
    scale: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    visible: false,
    factorIds: [],
    data: null
  }),
  computed: {
    downloadName: () => '灰霾过程特性'
  },
  methods: {
    formatData () {
      const {dataConfig} = this

      if (!dataConfig) {
        this.data = null
        return
      }

      const factorIdMap = this.defaultFactorIds.reduce((map, factorId) => {
        map[factorId] = true
        return map
      }, {})
      const {dimensions} = dataConfig
      const newDimensions = dimensions.filter(dimension => factorIdMap[dimension.factorId])

      this.data = Object.freeze({
        ...dataConfig,
        dimensions: factorIdMap['3507'] ? newDimensions.sort((a, b) => b.factorId - a.factorId) : [dimensions.find(dimension => dimension.id === '3507'), ...newDimensions]
      })

      setTimeout(() => {
        this.$emit('rendered')
      }, 0)
    },
    getChartComponent () {
      return this.$refs.chart.getChartComponent()
    }
  },
  watch: {
    dataConfig () {
      this.formatData()
    }
  },
  created () {
    this.formatData()
  }
}
</script>

<style lang="scss" scoped>
.dust-haze-chart-group {

}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/06Dust-Haze/DustHazeChartGroup.vue